import {
  ButtonCategory,
  ButtonCategoryStyle,
  ButtonType,
} from "@components/atoms/Button/types";

const getStyleForCategory = (
  category: ButtonCategory,
  type: ButtonType,
  disabled: boolean
): ButtonCategoryStyle => {
  if (disabled) {
    if (type === ButtonType.primary) {
      return {
        textColor: "primary-cont-disabled",
        background: "primary-bg-disabled",
        borderColor: `transparent`,
        hover: "transparent",
      };
    }
    if (type === ButtonType.secondary) {
      return {
        textColor: "secondary-cont-disabled",
        background: "transparent",
        borderColor: `secondary-bor-disabled`,
        hover: "transparent",
      };
    }
    if (type === ButtonType.tertiary) {
      return {
        textColor: "tertiary-cont-disabled",
        background: "tertiary-bg-disabled",
        borderColor: `transparent`,
        hover: "transparent",
      };
    }
  }

  if (type === ButtonType.primary) {
    if (category === ButtonCategory.default) {
      return {
        textColor: "primary-cont",
        background: "primary-bg-static",
        borderColor: `transparent`,
        hover: "primary-bg-hover",
      };
    }

    return {
      textColor: `${category}-05`,
      background: `${category}-01`,
      borderColor: `transparent`,
      hover: `${category}-02`,
    };
  }

  if (type === ButtonType.secondary) {
    if (category === ButtonCategory.default) {
      return {
        textColor: "secondary-cont",
        background: "transparent",
        borderColor: `secondary-bor-static`,
        hover: "secondary-bg-hover",
      };
    }

    return {
      textColor: `${category}-06`,
      background: `transparent`,
      borderColor: `${category}-01`,
      hover: `${category}-03`,
    };
  }

  if (type === ButtonType.tertiary) {
    if (category === ButtonCategory.default) {
      return {
        textColor: "tertiary-cont",
        background: "tertiary-bg-static",
        borderColor: `transparent`,
        hover: "transparent",
      };
    }

    return {
      textColor: `${category}-06`,
      background: `${category}-03`,
      borderColor: `transparent`,
      hover: "transparent",
    };
  }

  return {
    textColor: "primary-cont",
    background: "primary-bg-static",
    borderColor: `transparent`,
    hover: "primary-bg-hover",
  };
};

export { getStyleForCategory };
